<!-- 绑定成员 -->
<template>
  <div>
    <el-dialog
      :title="`绑定成员(已选${selfList.length})`"
      width="1000px"
      :visible.sync="selfShow"
      :close-on-click-modal="false"
      append-to-body
    >
      <div class="popup-main">
        <vxe-grid size="mini" border :height="256" :data="noChooseList" :columns="showColumn">
          <!-- slot_header -->
          <template #header_input="{ column }">
            <c-table-header
              :title="column.title"
              :field="column.field"
              :url="headerFilterUrl"
              @change="headerFilterChange"
            />
          </template>

          <!-- slot_default -->
          <template #default_operate="{ row }">
            <el-link
              size="mini"
              type="success"
              icon="vxe-icon-lock-fill"
              title="绑定"
              @click="itemAdd(row)"
            >
              绑定
            </el-link>
          </template>
        </vxe-grid>
        <vxe-grid class="m-t-10" size="mini" :height="256" :data="selfList" :columns="activeColumn">
          <!-- slot_default -->
          <template #default_leader="{ row }">
            <el-switch type="primary" v-model="row.is_leader" @change="toggleLeader(row)" />
          </template>
          <template #default_operate="{ rowIndex }">
            <el-link
              size="mini"
              type="danger"
              icon="vxe-icon-unlock-fill"
              title="解绑"
              @click="itemDelete(rowIndex)"
            >
              解绑
            </el-link>
          </template>
        </vxe-grid>
      </div>

      <div slot="footer">
        <el-button size="mini" @click="popupCancel">取消</el-button>
        <el-button size="mini" type="primary" @click="popupConfirm">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      required: true
    },
    list: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      selfShow: false,
      selfData: {},
      selfList: {},
      allList: [],
      headerFilterUrl: '/admin/gcvip/yuanGong2/searchHeard',
      filterData: {},
      showColumn: [
        {
          fixed: 'left',
          title: '序号',
          type: 'seq',
          width: 40
        },
        { field: 'yuan_gong_user_code', title: '员工编码', slots: { header: 'header_input' } },
        {
          field: 'yuan_gong_user_name',
          title: '员工姓名',
          width: 200,
          slots: { header: 'header_input' }
        },
        {
          field: 'department_str',
          width: 200,
          title: '所属部门',
          slots: { header: 'header_input' }
        },
        { field: 'job_station_str', title: '所属职位', slots: { header: 'header_input' } },
        { field: 'yuan_gong_user_phone', title: '联系电话', slots: { header: 'header_input' } },
        { title: '操作', slots: { default: 'default_operate' } }
      ],
      activeColumn: [
        {
          fixed: 'left',
          title: '序号',
          type: 'seq',
          width: 40
        },
        { field: 'yuan_gong_user_code', title: '员工编码' },
        {
          field: 'yuan_gong_user_name',
          title: '员工姓名',
          width: 120
        },
        { field: 'is_leader', width: 80, title: '设为组长', slots: { default: 'default_leader' } },
        { field: 'department_str', width: 200, title: '所属部门' },
        { field: 'job_station_str', title: '所属职位' },
        { field: 'yuan_gong_user_phone', title: '联系电话' },
        { title: '操作', slots: { default: 'default_operate' } }
      ],
      activeSheBeiIndex: ''
    }
  },
  computed: {
    // 未选择数据列表
    noChooseList() {
      let result = []
      this.allList.forEach((itemSt) => {
        let isNotRepect = this.selfList.every((itemNd) => {
          return itemSt.id !== itemNd.yuan_gong_id
        })
        if (isNotRepect) result.push(this.$util.deepCopy(itemSt))
      })
      return result
    }
  },
  watch: {
    selfShow(val) {
      this.$emit('update:show', val)
    }
  },
  mounted() {
    this.selfShow = this.show
    this.selfList = this.$util.deepCopy(this.list)
    this.getMuBanAllList()
  },
  methods: {
    // 头部筛选更新
    headerFilterChange(obj) {
      this.filterData[obj.field] = obj.value
      this.getMuBanAllList()
    },
    // 获取所有成员
    getMuBanAllList() {
      this.$api({
        method: 'post',
        url: '/admin/gcvip/yuanGong2/list',
        data: {
          filterData: this.filterData,
          pageSize: this.$constant.pageMax,
          sortData: {
            id: 'desc'
          }
        }
      }).then((res) => {
        if (res.status === 200) {
          // 初始化is_leader为false
          res.data.page.list.forEach((item) => {
            item.is_leader = false
          })
          this.allList = res.data.page.list
        }
      })
    },
    // 项-绑定
    itemAdd(row) {
      let activeRow = this.$util.deepCopy(row)
      let result = {
        ...activeRow,
        id: '',
        yuan_gong_id: activeRow.id
      }

      this.selfList.push(result)
    },
    // 项-解绑
    itemDelete(index) {
      this.selfList.splice(index, 1)
    },
    // 项-切换组长
    toggleLeader(row) {
      // 确保只有一个组长，将所有其他项的is_leader设为false,
      this.selfList.forEach((item) => {
        if (item.yuan_gong_user_code !== row.yuan_gong_user_code) {
          item.is_leader = false
        }
      })
    },
    // 项-设置
    async itemSet(index) {
      this.activeSheBeiIndex = index
    },
    // 弹窗取消
    popupCancel() {
      this.selfShow = false
      this.$emit('update:show', false)
    },
    // 弹窗确认
    popupConfirm() {
      this.$emit('success', this.selfList)
      this.popupCancel()
    }
  }
}
</script>

<style lang="less" scoped>
.popup-main {
  /deep/ .el-link {
    vertical-align: inherit;
  }
}
</style>
